import uniq from "lodash/uniq";
const range = (start, end) => [...Array(end + 1 - start).keys()].map((i) => i + start);
const normalizeInfinity = ({ width, height, col, row }, maxWidth) => ({
  col,
  row,
  height,
  width: Number.isFinite(width) ? width : maxWidth
});
const placeItemInGrid = (grid, item, value, overlapValue = value) => {
  let overlap = false;
  range(item.col, item.col + item.width - 1).forEach((x) => {
    range(item.row, item.row + item.height - 1).forEach((y) => {
      var _a, _b, _c;
      if (((_a = grid[y]) == null ? void 0 : _a[x]) !== void 0) {
        overlap = true;
      }
      ((_b = grid[y]) != null ? _b : grid[y] = [])[x] = ((_c = grid[y]) == null ? void 0 : _c[x]) !== void 0 ? overlapValue : value;
    });
  });
  return overlap;
};
const itemsOverlap = (items) => {
  if (items.length === 0) {
    return false;
  }
  const grid = [];
  for (const item of items) {
    if (placeItemInGrid(grid, item, true)) {
      return true;
    }
  }
  return false;
};
const rowIsEmpty = (grid, row) => {
  var _a;
  return ((_a = grid[row]) != null ? _a : []).every((cell) => cell === void 0);
};
const findGaps = (_items, minWidth = 1, maxWidth = 13) => {
  var _a, _b;
  if (_items.length === 0) {
    return [];
  }
  const items = _items.map((item) => normalizeInfinity(item, maxWidth));
  const minY = Math.min(...items.map(({ row }) => row));
  const maxY = Math.max(...items.map(({ row, height }) => row + height - 1));
  if (itemsOverlap(items)) {
    return [];
  }
  const grid = [];
  items.forEach((item) => placeItemInGrid(grid, item, true));
  const gaps = [];
  for (let x = minWidth; x < maxWidth - 1; x++) {
    for (let y = minY; y <= maxY; y++) {
      if (!rowIsEmpty(grid, y) && ((_a = grid[y]) == null ? void 0 : _a[x]) === void 0) {
        const gap = { col: x, row: y, height: 1, width: 1 };
        while (gap.col + gap.width < maxWidth && ((_b = grid[y]) == null ? void 0 : _b[gap.col + gap.width]) === void 0) {
          gap.width += 1;
        }
        if (gap.width > 1) {
          while (!rowIsEmpty(grid, gap.row + gap.height) && gap.row + gap.height <= maxY) {
            if (range(gap.col, gap.col + gap.width - 1).every((k) => {
              var _a2;
              return !((_a2 = grid[gap.row + gap.height]) == null ? void 0 : _a2[k]);
            })) {
              gap.height += 1;
            } else {
              break;
            }
          }
          placeItemInGrid(grid, gap, true);
          gaps.push(gap);
        }
      }
    }
  }
  return uniq(gaps);
};
export default findGaps;
